import { Box, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as BoxedArrowRightIcon } from '../../../assets/icons/boxed-arrow-right-icon.svg';
import { SimpleNode } from '../../../models/models';
import { openDialog } from '../../../store/dialog/dialog.action';
import { DIALOG_TYPES } from '../../../store/dialog/dialog.types';
import { selectProjectSelected } from '../../../store/project/project.selector';
import NodesList from '../../nodes-list/nodes-list.component';
import { FlexBoxFullWRowBetween } from '../layout.styles';
import { CustomMainBar, CustomMainBarTitle } from './main-bar.styles';

const MainBar = ({ nodes }: { nodes: SimpleNode[] }) => {
    const dispatch = useDispatch();

    const projectSelected = useSelector(selectProjectSelected);

    const handleGoToProjects = () => {
        dispatch(openDialog(DIALOG_TYPES.SELECT_PROJECT));
    };

    return (
        <CustomMainBar>
            <FlexBoxFullWRowBetween>
                <CustomMainBarTitle>
                    LE MIE ATTIVITA'{' '}
                    {projectSelected && ` - ${projectSelected.name}`}
                </CustomMainBarTitle>
                <Box display={'flex'} gap={2} alignItems={'center'}>
                    <CustomMainBarTitle>Vai ai progetti</CustomMainBarTitle>
                    <BoxedArrowRightIcon
                        style={{ cursor: 'pointer' }}
                        onClick={handleGoToProjects}
                    />
                </Box>
            </FlexBoxFullWRowBetween>

            <Box height={20} />
            {nodes.length === 0 && <Typography>Nessuna Attività</Typography>}
            <NodesList nodes={nodes} />
        </CustomMainBar>
    );
};

export default MainBar;
